import { Box } from '@mui/material';

interface ScreenshotShowcaseProps {
  variant?: 'default' | 'compact';
}

export function ScreenshotShowcase({ variant = 'default' }: ScreenshotShowcaseProps) {
  const isCompact = variant === 'compact';

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      {/* Dashboard screenshot (background) — Sarah sample-client capture */}
      <Box
        component="img"
        src="/images/product/sarah/goals-tree-960.webp"
        srcSet="/images/product/sarah/goals-tree-640.webp 640w, /images/product/sarah/goals-tree-960.webp 960w, /images/product/sarah/goals-tree-1440.webp 1440w"
        sizes="(max-width: 768px) 100vw, 60vw"
        alt="Clinician dashboard showing a client's rehab goals organised under their aspirations"
        sx={{
          width: '100%',
          height: 'auto',
          borderRadius: isCompact ? 3 : 4,
          boxShadow: isCompact ? undefined : '0 20px 40px rgba(0,0,0,0.1)',
        }}
      />
      {/* App screenshot (overlay) — what the client sees on mobile */}
      <Box
        component="img"
        src="/images/product/sarah/app-home-390.webp"
        alt="Mobile app home screen with rehab goals and today's reminders"
        sx={{
          position: 'absolute',
          bottom: { xs: -15, md: isCompact ? -25 : -40 },
          right: { xs: -8, md: isCompact ? -15 : -30 },
          width: { xs: '30%', md: isCompact ? '25%' : '28%' },
          height: 'auto',
          borderRadius: 2,
          boxShadow: '0 12px 40px rgba(0,0,0,0.2)',
          border: '3px solid white',
        }}
      />
    </Box>
  );
}
